import {GET_PERSONAL} from 'shared/constants/ActionTypes';
import ItemCollections, {useGetItem} from 'redux/cache';
import {API} from 'shared/constants/AppEnums';
const itemCollections = new ItemCollections();
export const getPersonal = (searchText) => {
  let keyUrl = API.PERSONALS;
  let save = searchText ? false : true;
  searchText ? (keyUrl += '?search=' + searchText) : '';
  return useGetItem(itemCollections, keyUrl, GET_PERSONAL, true, save);
};
